import * as types from '@/store/mutation-types';
import api from '@/store/api';
import { logAction } from '../logActions';
import log from '@/logger';

export const addPartComment = ({ commit, state, getters }, { part, project, text }) => {
  var authorPersonId = getters.loggedInPerson ? getters.loggedInPerson._id : '';
  return api
    .createPartComment({ projectId: project._id, part, text, authorPersonId, authorUsername: getters.username })
    .then(async (partComment) => {
      // setPartProperties({commit, state}, {updatePart: part, newPartProperties: newPartProperties});
      commit(types.addPartComment, partComment);
      logAction({ commit, state }, { project: project, object: partComment, reason: 'Added Part Comment' });

      return partComment;
    })
    .catch((e) => {
      log.error('Error occurered while creating comment', e);
      commit(types.setSyncStatus, {
        status: 'Error',
        live: 0,
        message: 'Database Error occurred while adding partComment',
        count: 1,
      });
    });
};

export const getPartComments = ({ commit, state }, { projectId, partId }) => {
  return api.getPartComments(projectId, partId);
};

export const getPartCommentsForPerson = ({ commit, state }, { personId }) => {
  return api.getPartCommentsForPerson(personId);
};

export const syncPartComment = ({ commit, state }, partComment) => {
  commit(types.syncPartComment, partComment);
};



// WEBPACK FOOTER //
// ./src/store/partComment/partCommentActions.js